import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function getFreeTimeAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "clinic_code": "0000000002",
          "clinic_name": "Dent&Co牙醫診所1",
          "doctor_code": "8d307RzhvYdT",
          "doctor_name": "測試診所三號",
          "use_manual_free_time": true,
          "web_appointment_status": "2",
          "current_appointment_status": "1",
          "tomorrow_appointment_status": "1",
          "weekly": [
            [],
            [],
            ["14:00", "14:30", "15:00", "15:30"],
            [],
            [],
            [],
            []
          ],
          "single": {
            "2021-06-01": ["14:00", "14:30"],
            "2021-06-02": [],
            "2021-06-10": ["07:00", "14:00"],
            "2021-06-18": ["15:00", "15:30", "16:00", "16:30", "17:00"],
            "2021-06-21": ["10:00", "10:30", "11:00"]
          },
          "closed": ["2021-09-23", "2021-09-24"]
        }
      ]
    })
  }
  const url = apiUrl('freetime')
  return axios.get(url, {params})
}

export function updateFreeTimeAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('freetime')
  return axios.post(url, data)
}

export function getFreeTimeModeAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "line_appointment_status": 0,
        "web_appointment_status": 0,
        "google_map_appointment_status": 0,
        "use_manual_free_time":false
      }
    })
  }
  const url = apiUrl('freetime-mode')
  return axios.get(url, {params})
}

export function updateFreeTimeModeAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('freetime-mode')
  return axios.put(url, data)
}

export function getFreeTimeDetailAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "clinic_channel": "1657424851",
        "clinic_line_page": "https://www.facebook.com/",
        "doctor_channel": "1657558159",
        "doctor_line_page": "https://doctor.dentco.tw/",
        // ...
      }
    })
  }
  const url = apiUrl('freetime-detail')
  return axios.get(url, {params})
}

export function updateFreeTimeDetailAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('freetime-detail')
  return axios.put(url, data)
}

export function updateClinicWideAppointmentSettingAPI(data) {
  if (useMock) {
    return Promise.resolve({ data: { "messages": "成功" } })
  }
  const url = apiUrl('freetime-clinic-wide-setting')
  return axios.put(url, data)
}

export function getManualSettingAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "weekly": [],
        "closed": [],
        "single": []
      }
    })
  }
  const url = apiUrl('manual-freetime-setting')
  return axios.get(url, {params})
}

export function updateManualSettingAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('manual-freetime-setting')
  return axios.put(url, data)
}

export function getLastDate(params) {
  if (useMock) {
    return Promise.resolve({
      data: {}
    })
  }
  const url = apiUrl('manual-freetime-month-count')
  return axios.get(url, {params})
}

